const BuyButton = () => (
  <div className="offers-price-badge-buy-button">
    <span>Compre</span>
    <i className="glyph glyph-cart"></i>
  </div>
)

export default BuyButton
